export default __webpack_public_path__ + "static/WI-statute-TOC-1ffc302371d5ed88b591f1d312fdf43d.png";